import { IState } from "@/redux/store.types";
import { getApiDataState } from "@/redux/utils";

import { $VatPrefixesModuleName } from "./vatPrefixes.types";

const getVatPrefixes = (state: IState) => {
    return getApiDataState(state, $VatPrefixesModuleName)?.data?.prefixes || [];
};

export { getVatPrefixes };
